import { MapPin } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { imgSrc } from "@/lib/api";
import { track } from "@/lib/analytics";

export default function Experiences({ experiences, settings }) {
  if (!experiences?.length) return null;
  return (
    <section id="karwar" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-20 sm:px-8 lg:px-16 lg:py-32" data-testid="experiences-section">
      <Reveal>
        <p className="eyebrow mb-4">Discover Karwar</p>
        <h2 className="max-w-3xl font-serif text-2xl leading-snug tracking-tight text-cream sm:text-3xl lg:text-4xl">
          The coast, the river, <span className="italic text-copper-gradient">the islands.</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {experiences.map((ex, i) => (
          <Reveal key={ex.id || i} delay={0.06 * (i % 3)}>
            <article className="card-hover group overflow-hidden rounded-2xl border border-white/10 bg-charcoal-800" data-testid={`experience-card-${ex.id || i}`}>
              <div className="relative overflow-hidden">
                <img src={imgSrc(ex.image)} alt={ex.title} loading="lazy"
                  className="aspect-[16/10] w-full object-cover transition-transform duration-[1.3s] ease-out group-hover:scale-105" />
                {ex.distance && (
                  <span className="absolute bottom-3 left-3 flex items-center gap-1.5 rounded-full bg-charcoal/80 px-3 py-1 text-[10px] font-mono uppercase tracking-[0.15em] text-copper-300 backdrop-blur">
                    <MapPin className="h-3 w-3" /> {ex.distance}
                  </span>
                )}
              </div>
              <div className="p-6">
                <h3 className="font-serif text-xl text-cream">{ex.title}</h3>
                <p className="mt-2 text-sm font-light leading-relaxed text-cream-muted">{ex.description}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
      {settings?.maps_embed_url && (
        <Reveal delay={0.15} className="mt-14">
          <div className="overflow-hidden rounded-2xl border border-copper/25" data-testid="karwar-map">
            <iframe
              title="Map of Mystique Copper Villa and Karwar attractions"
              src={settings.maps_embed_url}
              className="h-[420px] w-full grayscale-[35%] contrast-[1.05]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              onLoad={() => track("map_view")}
            />
          </div>
        </Reveal>
      )}
    </section>
  );
}
